import { toDisplayString as _toDisplayString, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/remove-circled.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-76b7247e")

_pushScopeId("data-v-76b7247e")
const _hoisted_1 = {
  class: "slot-modal calendar-modal d-flex justify-content-between flex-column",
  style: {"height":"80vh"}
}
const _hoisted_2 = {
  class: "modal-up",
  style: {"height":"calc(80vh - 134px)"}
}
const _hoisted_3 = { class: "tags-modal-header" }
const _hoisted_4 = { class: "fs-16" }
const _hoisted_5 = { class: "tags-modal-create-panel" }
const _hoisted_6 = { class: "mb-1" }
const _hoisted_7 = { class: "add-tag-row" }
const _hoisted_8 = { class: "btn green-button h40" }
const _hoisted_9 = /*#__PURE__*/_createVNode("hr", { style: {"margin-block":"25px"} }, null, -1)
const _hoisted_10 = { class: "tags-modal-body h-100" }
const _hoisted_11 = { class: "mb-2 fs-16" }
const _hoisted_12 = { class: "tag-items tags-management" }
const _hoisted_13 = {
  key: 0,
  class: "edit-tag-item tag-item"
}
const _hoisted_14 = { class: "d-flex px-0" }
const _hoisted_15 = {
  key: 1,
  class: "tag-item"
}
const _hoisted_16 = { class: "tag-item-name" }
const _hoisted_17 = { class: "tag-actions" }
const _hoisted_18 = { class: "modal-down" }
const _hoisted_19 = { class: "tags-modal-footer" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_OverlayModal = _resolveComponent("OverlayModal")

  return (_openBlock(), _createBlock(_component_OverlayModal, {
    isOpen: _ctx.isOpen,
    closeOnClick: true,
    onClose: _ctx.close,
    class: "modal-limit pt-5",
    modalWidth: 400
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('label.tags-management')), 1),
            _createVNode("span", {
              class: "icon-f icon-delete-cross c-grey fs-16",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
            })
          ]),
          _createVNode("div", _hoisted_5, [
            _createVNode("form", {
              onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.submitForm($event)), ["prevent"])),
              novalidate: ""
            }, [
              _createVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('label.create-tag')) + ":", 1),
              _createVNode("div", _hoisted_7, [
                _withDirectives(_createVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.newTagName = $event)),
                  placeholder: _ctx.$t('label.tag-name'),
                  required: "",
                  class: "bookit-input product-input form-control w-100 h40"
                }, null, 8, ["placeholder"]), [
                  [
                    _vModelText,
                    _ctx.newTagName,
                    void 0,
                    { trim: true }
                  ]
                ]),
                _createVNode("button", _hoisted_8, _toDisplayString(_ctx.$t('label.create-tag')), 1)
              ])
            ], 32)
          ]),
          _hoisted_9,
          _createVNode("div", _hoisted_10, [
            _createVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('label.all-created-tags')), 1),
            _createVNode("div", _hoisted_12, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tags, (tag) => {
                return (_openBlock(), _createBlock("div", {
                  key: tag.id
                }, [
                  (_ctx.editingTag?.id === tag.id)
                    ? (_openBlock(), _createBlock("div", _hoisted_13, [
                        _withDirectives(_createVNode("input", {
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.editingTag.name = $event))
                        }, null, 512), [
                          [
                            _vModelText,
                            _ctx.editingTag.name,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        _createVNode("div", _hoisted_14, [
                          _createVNode("i", {
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.saveTag(false))),
                            class: "icon-f icon-circle-check",
                            style: {"color":"#9CD330"}
                          }),
                          _createVNode("span", {
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.editingTag = null)),
                            class: "remove-button"
                          })
                        ])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_15, [
                        _createVNode("div", _hoisted_16, _toDisplayString(tag.name), 1),
                        _createVNode("div", _hoisted_17, [
                          _createVNode("i", {
                            onClick: ($event: any) => (_ctx.editTag(tag)),
                            class: "icon-f icon-pencil-edit fs-20 sub-tag-edit"
                          }, null, 8, ["onClick"]),
                          _createVNode("img", {
                            onClick: ($event: any) => (_ctx.onDelete(tag.id)),
                            style: {"width":"20px","margin-inline-start":"14px","cursor":"pointer"},
                            src: _imports_0,
                            alt: ""
                          }, null, 8, ["onClick"])
                        ])
                      ]))
                ]))
              }), 128))
            ])
          ])
        ]),
        _createVNode("div", _hoisted_18, [
          _createVNode("div", _hoisted_19, [
            _createVNode("button", {
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
              class: "close-modal col-8"
            }, _toDisplayString(_ctx.$t('button.v2.close')), 1)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["isOpen", "onClose"]))
})